import { forwardRef } from 'react';
import { IoBriefcaseOutline, IoCheckmark } from 'react-icons/io5';

import { Button, ButtonProps, createPolymorphicComponent } from '@mantine/core';

export enum ConnectButtonState {
    DEFAULT,
    CONNECTED,
}

type ConnectButtonProps = {
    state: ConnectButtonState;
    buttonProps?: ButtonProps;
};

const _ConnectButton = forwardRef<HTMLButtonElement, ConnectButtonProps>(({ state, buttonProps }, ref) => {
    const connectButtonProps: ButtonProps = {
        variant: 'gradient',
        leftSection: <IoBriefcaseOutline />,
        children: 'Add partner',
        size: 'xs',
        ...buttonProps,
    };

    if (state === ConnectButtonState.CONNECTED) {
        connectButtonProps.variant = 'filled';
        connectButtonProps.color = 'green';
        connectButtonProps.children = 'Connected';
        connectButtonProps.leftSection = <IoCheckmark />;
    }

    return <Button {...connectButtonProps} ref={ref} />;
});

_ConnectButton.displayName = 'ConnectButton';

export const ConnectButton = createPolymorphicComponent<'button', ConnectButtonProps>(_ConnectButton);
